export default "__VITE_ASSET__C9jqX48V__"